
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'hot': {
    width: 16,
    height: 16,
    viewBox: '0 0 15 16',
    data: '<path pid="0" d="M4.953 15.733Q0 15.2 0 11c0-4.2 2.536-5.93 4.645-6.984A4.683 4.683 0 0 0 7.083 0q3.3 1.859 3.771 4.187a5.124 5.124 0 0 1-.963 4.258 2.673 2.673 0 0 0 2.267-1.277 6.215 6.215 0 0 0 .831-2.1q3.079 4.734 1.444 7.149A11.986 11.986 0 0 1 10.375 16q-2.941-1.323-3.668-2.805a5.179 5.179 0 0 1-.2-3.595 3.6 3.6 0 0 0-2.782 2.616 3.812 3.812 0 0 0 1.228 3.517z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
